import src from "IMAGE";
export default { src, width: 192, height: 127, blurWidth: 0, blurHeight: 0};
